import { ALWAYS_ON_SECTION, SECTION_KEYS_WITH_PORTAL, parseSectionSetting } from '@vigeo/shared';

/**
 * Whether THIS WEB BUILD has the candidate portal switched on (#625).
 *
 * The same build setting the HR app's menu reads, `VITE_ENABLED_SECTIONS` (#610), with the one more
 * name the server knows: `portal`. Not given, the portal is open, as it always was. Given without
 * `portal` (production's `roster`), the page says "not available yet" at once, before asking for a
 * code and without asking the server anything.
 *
 * This only decides what the page shows first. The server is the lock: it refuses every portal
 * route when it was packaged without `portal`, whatever this build says, and the page shows the
 * same message when it meets that refusal.
 */
export function portalOnInThisBuild(): boolean {
  return parseSectionSetting(import.meta.env.VITE_ENABLED_SECTIONS, SECTION_KEYS_WITH_PORTAL, ALWAYS_ON_SECTION).has('portal');
}
